import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Number } from '@independent-software/typeui/formatters/Number';
import { Label } from '@independent-software/typeui/controls/Label';

import { AuthContext } from '../../AuthContext';
import { Section, Viewer } from '../../modules';
import { Parameter, ParameterFactory, Parametercategory } from '../../resource/'; 
import { Output } from '../../controls/Output';

const ViewParameter = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const handleEdit = () => {
    navigate(`/parameters/edit/${parseInt(id)}`);
  }

  const handleDelete = () => {
    ToastService.toast("Parameter deleted.");
    navigate('/parameters');
  }    

  const handleCategoryClick = (category: Parametercategory) => {
    navigate(`/parametercategories/${category.id}`);
  }

  return (
    <Viewer<Parameter> 
      auth={auth}
      id={parseInt(id)}
      factory={ParameterFactory}
      canEdit='can_edit_parameters'
      canDelete='can_delete_parameters'
      onEdit={handleEdit}
      onDelete={handleDelete}
      content={(parameter: Parameter) => 
        <>
          <Section dark padded>
            <Header size="h2">{parameter.name} ({parameter.unit})</Header>
          </Section>
          <Tabs underlined>
            <Tabs.Pane label="General">
              <Section padded="very">
                <Flex.Columns count={2}>
                  <>
                    <Output label="Name" hint="Parameter name">{parameter.name}</Output>
                    <Output label="Unit" hint="Parameter unit">{parameter.unit}</Output>
                    <Output label="Decimals" hint="Number of decimals"><Number value={parameter.decimals} decimals={0}/></Output>
                  </>
                  <>
                    <Output label="Type" hint="Parameter type">{parameter.type != null ? (parameter.type.charAt(0).toUpperCase() + parameter.type.slice(1)) : '-'}</Output>
                    <Output label="Formula" hint="Parameter Formula">{parameter.formula}</Output>
                    <Output label="Alternative" hint="Alternative names">{parameter.alternative}</Output>
                  </>
                </Flex.Columns>
                <Output nobackground label="Categories">
                  {parameter.parametercategories.map(cat => 
                    <Label onClick={auth.hasRight('can_view_stationcategories') ?  () => handleCategoryClick(cat) : null} basic tag key={cat.id}>{cat.name}</Label>
                  )}
                </Output>
              </Section>
            </Tabs.Pane>
            <Tabs.Pane label="Limits">
              <Section padded="very">
                <Flex.Columns count={2}>
                  <>
                    <Output label="Minimum" hint="Minimum allowable value"><Number value={parameter.minvalue} decimals={parameter.decimals}/></Output>
                    <Output label="Maximum" hint="Maximum allowable value"><Number value={parameter.maxvalue} decimals={parameter.decimals}/></Output>
                  </>
                  <>
                    <Output label="Recommended minimum" hint="Recommended minimum allowable value"><Number value={parameter.recommended_low} decimals={parameter.decimals}/></Output>
                    <Output label="Recommended maximum" hint="Recommended maximum allowable value"><Number value={parameter.recommended_high} decimals={parameter.decimals}/></Output>
                  </>
                </Flex.Columns>
              </Section>
            </Tabs.Pane>              
          </Tabs>
        </>}>
    </Viewer>
  );
}

export { ViewParameter }

